import { inject, Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { StableService } from './stable.service';
import { StableBoxService } from './stableBox.service';
import { StableActivityService } from './stableActivityService.service';
import { StableGroupService } from './stableGroup.service';
import { AnimalsService } from './animals.service';
import { StableLoadsService } from './stable-loads.service';

@Injectable({ providedIn: 'root' })
export class LivestockCoreDataService {
  // Services
  stableService = inject(StableService);
  stableBoxService = inject(StableBoxService);
  stableActivityService = inject(StableActivityService);
  stableGroupService = inject(StableGroupService);
  animalsService = inject(AnimalsService);
  stableLoadsService = inject(StableLoadsService);

  /**
   * Composes all API calls needed for the Livestock Application Mode into a single stream.
   * This method RETURNS the observable, allowing the caller to manage the subscription.
   * @returns An observable that emits when all data has been fetched.
   */
  loadAllData(): Observable<any[]> {
    const dataStreams$ = [
      this.stableService.getStables(),
      this.stableBoxService.getStableBoxs(),
      this.stableActivityService.getStableActivities(),
      this.stableActivityService.getStableActivityGrouped(),
      this.stableGroupService.getStableGroups(),
      this.animalsService.getAnimals(),
      this.animalsService.getAnimalBreed(),
      this.stableLoadsService.getStableLoads(),
    ];

    // Return the forkJoin observable without subscribing here
    return forkJoin(dataStreams$);
  }
}
